export const styles = theme => ({
    table: {
        margin: "15px 0px",
        width: "80%"
    },
});
